<button
  [routerLink]="linkTo() ? linkTo() : undefined"
  pButton
  pRipple
  [type]="type()"
  [icon]="icon() ? 'pi ' + icon() : ''"
  [class]="buttonClass() + ' ' + buttonClassName()"
  [class.custom-background]="buttonSettings()?.buttonColor"
  [class.custom-text]="buttonSettings()?.buttonTextColor"
  [class.custom-hover-background]="buttonSettings()?.buttonHoverColor"
  [class.custom-hover-text]="buttonSettings()?.buttonHoverTextColor"
  [style.--button-color]="buttonSettings()?.buttonColor"
  [style.--button-text-color]="buttonSettings()?.buttonTextColor"
  [style.--button-hover-color]="buttonSettings()?.buttonHoverColor"
  [style.--button-hover-text-color]="buttonSettings()?.buttonHoverTextColor"
  [label]="label()"
  [attr.aria-label]="label()"
  [iconPos]="iconPosition()"
  [style.width]="fullWidth() ? '100%' : 'auto'"
  (click)="handleClickEvent($event)"
  [disabled]="disabled()"
  [loading]="loading()"
></button>
